import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  almostDoneTitle: {
    defaultMessage: "You're almost done! Please review and complete the remaining action items",
    id: 'hQZSum',
    description: 'Title on card within ASN informing user of next steps',
  },
  freightDropOffDateConfirmedTitle: {
    defaultMessage: 'Your freight drop-off dates are confirmed',
    id: 'hmVapJ',
    description: 'Title to explain to user their confirmed freight drop-off date',
  },
  freightDropoffSubmissionPendingTitle: {
    defaultMessage: 'Your freight drop-off dates are pending approval',
    id: 'pDXtFz',
    description: 'Title to explain to user their freight drop-off dates',
  },
  freightScheduleTitle: {
    defaultMessage: 'Schedule Freight',
    id: 'MQpxsp',
    description: 'Title to explain to user their freight drop-off dates',
  },
  freightDropOffDateConfirmedText: {
    defaultMessage: 'Your carrier <b>{carrierName}</b> will be arriving at <b>{recievingCenter}</b> on <b>{datetime}</b>.',
    id: 'bk5Pu5',
    description: 'Body text explaining to user their confirmed freight drop-off date',
  },
  freightDropoffSubmissionPendingText: {
    defaultMessage: 'We will update you when a date is confirmed for drop-off.',
    id: 'tCkh20',
    description: 'Body text explaining we will inform them of dropoff dates.',
  },
  freightDropoffRescheduleText: {
    defaultMessage: 'Reschedule your drop-off appointment',
    id: 'Q44moo',
    description: 'Button text to reschedule drop-off appointment',
  },
  freightScheduleText: {
    defaultMessage: 'Propose up to three freight drop-off dates for your ASN.',
    id: '4GLZNz',
    description: 'Body text explaining we will inform them of dropoff dates.',
  },
  downloadWarehouseLabelsTitle: {
    defaultMessage: 'Download warehouse receiving labels',
    id: 'M9VzCV',
    description: 'Title text of step to inform user how to download their labels',
  },
  downloadWarehouseLabelsText: {
    defaultMessage:
      'You must print these warehouse receiving labels and attach them to their corresponding parcels/pallets so the warehouse can receive and store your items properly.',
    id: '6hzqCj',
    description: 'Body text explaining how to download a warehouse label',
  },
  downloadLabelsButtonText: {
    defaultMessage: 'Download Labels',
    id: 'gRpNo2',
    description: 'Text of button for a user to download their labels',
  },
  configureShipmentsTitle: {
    defaultMessage: 'Configure Shipments in ShipStation (optional)',
    id: '/IYJ9F',
    description: 'Title text of step to configure your shipments',
  },
  configureShipmentsText: {
    defaultMessage: 'If you use ShipStation to print shipping labels, click below to set up your shipments.',
    id: 'sae5XM',
    description: 'Body text explaining how to configure your shipments',
  },
  configureShipmentsButtonText: {
    defaultMessage: 'Configure Shipments',
    id: 'Kc/JYI',
    description: 'Button Text for a user to configure their shipments',
  },
  proposeDropOffDatesButtonText: {
    defaultMessage: 'Propose Drop-Off Dates',
    id: '+0zFF1',
    description: 'Button Text for a user to choose drop off times and configure freight info',
  },
});
